import { render, staticRenderFns } from "./GuestbookFooter.vue?vue&type=template&id=02009955&scoped=true&"
import script from "./GuestbookFooter.vue?vue&type=script&lang=js&"
export * from "./GuestbookFooter.vue?vue&type=script&lang=js&"
import style0 from "./GuestbookFooter.vue?vue&type=style&index=0&id=02009955&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02009955",
  null
  
)

export default component.exports